import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import { productTypes } from '../../../../types/products';

import { isFetching } from '../../reducer';

import { TranslatedCopy } from '../../../../intl/TranslatedCopy';
import { NoResults, Spinner } from '../../../../components';
import LoadingMessage from '~COMPONENTS/spinner/LoadingMessage';

import { OrderReturnsPageProduct } from '../OrderReturnsPageProduct';

export const OrderReturnsPageSelect = ({
  hasMore,
  loadInfiniteScrollReturns,
  products,
  returnableProducts,
  isFetching,
  getReturnData,
  returnsForm,
  onFormValueUpdate,
  currencyCode,
  isSelectAllProducts,
  submittableReturnsList,
  setHasQuantityError,
  setIsSelectAllProducts
}) => {
  useEffect(() => {
    const hasQuantityErrors =
      submittableReturnsList?.some(submittableReturn => {
        const product = returnableProducts.find(
          returnableProduct => returnableProduct.productCode === submittableReturn.productCode
        );
        const size = product?.sizes.find(p => p.code === submittableReturn.sizeCode);
        return size && submittableReturn.quantity > size.returnableQuantity;
      }) || false;

    if (!hasQuantityErrors) {
      setHasQuantityError(false);
    }
  }, [JSON.stringify(submittableReturnsList)]);

  return (
    <div className='orderReturns__select flex-container u-full-width'>
      {isFetching ? (
        <LoadingMessage title={new TranslatedCopy({ id: 'orderreturns.returnableProducts' }).toString()} />
      ) : (
        <>
          {returnableProducts && returnableProducts.length > 0 && products && products.length > 0 ? (
            <InfiniteScroll
              element='div'
              className='u-full-width'
              pageStart={0}
              loader={
                <div key={0} className='flex-container center u-full-width'>
                  <Spinner />
                </div>
              }
              loadMore={loadInfiniteScrollReturns}
              hasMore={hasMore}
              initialLoad={false}
              threshold={50}
            >
              {products.map(product => (
                <OrderReturnsPageProduct
                  key={JSON.stringify(product)}
                  product={product}
                  returnableData={getReturnData(product.productCode)}
                  returnsForm={returnsForm}
                  onFormValueUpdate={onFormValueUpdate}
                  currencyCode={currencyCode}
                  sizeGrid
                  isSelectAllProducts={isSelectAllProducts}
                  submittableReturnsList={submittableReturnsList}
                  setHasQuantityError={setHasQuantityError}
                  setIsSelectAllProducts={setIsSelectAllProducts}
                />
              ))}
            </InfiniteScroll>
          ) : (
            <NoResults titleId='orderreturns.noProducts' />
          )}
        </>
      )}
    </div>
  );
};

OrderReturnsPageSelect.propTypes = {
  hasMore: PropTypes.bool.isRequired,
  loadInfiniteScrollReturns: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(productTypes),
  returnableProducts: PropTypes.array,
  isFetching: PropTypes.bool.isRequired,
  getReturnData: PropTypes.func.isRequired,
  returnsForm: PropTypes.any,
  onFormValueUpdate: PropTypes.func.isRequired,
  currencyCode: PropTypes.string,
  isSelectAllProducts: PropTypes.bool,
  submittableReturnsList: PropTypes.array.isRequired,
  setHasQuantityError: PropTypes.func.isRequired,
  setIsSelectAllProducts: PropTypes.func.isRequired
};

OrderReturnsPageSelect.defaultProps = {
  products: null,
  returnableProducts: null,
  returnsForm: null,
  currencyCode: null,
  isSelectAllProducts: false
};

const mapStateToProps = state => ({
  isFetching: isFetching(state)
});

const connector = connect(mapStateToProps, {});

export default connector(OrderReturnsPageSelect);
